"use strict";
import React from "react";
import "art/modes/dom";
import { Group } from "react-art";
import Rectangle from "react-art/shapes/rectangle";
import { getDisplayName } from "./utils";
import Vector from "immutable-vector2d";
const CropElement = (props) => {
  return /* @__PURE__ */ React.createElement(Group, { x: 0, y: 0 }, /* @__PURE__ */ React.createElement(Group, { x: 0, y: 0 }, /* @__PURE__ */ React.createElement(Rectangle, { width: 5e3, height: props.y, fill: "#000", opacity: 0.2 }, "shadow")), /* @__PURE__ */ React.createElement(Group, { x: 0, y: props.y }, /* @__PURE__ */ React.createElement(Rectangle, { width: props.x, height: 3e3, fill: "#000", opacity: 0.2 }, "shadow")), /* @__PURE__ */ React.createElement(Group, { x: props.x + props.width, y: props.y }, /* @__PURE__ */ React.createElement(Rectangle, { width: 3e3, height: 3e3, fill: "#000", opacity: 0.2 }, "shadow")), /* @__PURE__ */ React.createElement(Group, { x: props.x, y: props.y + props.height }, /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: 4e3 - props.height,
      fill: "#000",
      opacity: 0.2
    },
    "shadow"
  )), /* @__PURE__ */ React.createElement(Group, { x: props.x, y: props.y }, /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: props.height,
      cursor: props.annotating ? "move" : "default",
      stroke: props.selected ? "#aaa" : "#ddd",
      strokeWidth: props.annotating && props.cropping ? 2 : 0
    },
    "Crop area"
  )));
};
CropElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
CropElement.typeID = "Crop";
CropElement.displayName = getDisplayName(CropElement);
CropElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default CropElement;
